import type { IconContainerProps } from './typings'

import { IconContainer } from './elements/IconContainer'

export function CalendarSchedule(props: IconContainerProps) {
  return (
    <IconContainer {...props}>
      <svg viewBox="0 0 48 48">
        <path
          d="M6 17.7393H42V38.0871C42 38.9173 41.6702 39.7136 41.0831 40.3006C40.496 40.8877 39.6998 41.2175 38.8696 41.2175H9.13043C8.30019 41.2175 7.50395 40.8877 6.91688 40.3006C6.32981 39.7136 6 38.9173 6 38.0871V17.7393Z"
          fill="#A1C1E6"
        />
        <path
          d="M9.13043 9.91309H38.8696C39.6998 9.91309 40.496 10.2429 41.0831 10.83C41.6702 11.417 42 12.2133 42 13.0435V17.7392H6V13.0435C6 12.2133 6.32981 11.417 6.91688 10.83C7.50395 10.2429 8.30019 9.91309 9.13043 9.91309Z"
          fill="#4383CC"
        />
        <path
          d="M17.7379 6H16.1726C15.3082 6 14.6074 6.70077 14.6074 7.56522V12.2609C14.6074 13.1253 15.3082 13.8261 16.1726 13.8261H17.7379C18.6023 13.8261 19.3031 13.1253 19.3031 12.2609V7.56522C19.3031 6.70077 18.6023 6 17.7379 6Z"
          fill="#A1C1E6"
        />
        <path
          d="M31.8257 6H30.2605C29.3961 6 28.6953 6.70077 28.6953 7.56522V12.2609C28.6953 13.1253 29.3961 13.8261 30.2605 13.8261H31.8257C32.6902 13.8261 33.391 13.1253 33.391 12.2609V7.56522C33.391 6.70077 32.6902 6 31.8257 6Z"
          fill="#A1C1E6"
        />
        <path
          d="M24.0013 38.0865C28.7557 38.0865 32.61 34.2323 32.61 29.4778C32.61 24.7234 28.7557 20.8691 24.0013 20.8691C19.2468 20.8691 15.3926 24.7234 15.3926 29.4778C15.3926 34.2323 19.2468 38.0865 24.0013 38.0865Z"
          fill="#0E4686"
        />
        <path
          d="M28.697 30.2603H23.2188V23.9994C23.2188 23.7918 23.3012 23.5928 23.448 23.446C23.5947 23.2992 23.7938 23.2168 24.0014 23.2168C24.2089 23.2168 24.408 23.2992 24.5547 23.446C24.7015 23.5928 24.784 23.7918 24.784 23.9994V28.6951H28.697C28.9046 28.6951 29.1036 28.7775 29.2504 28.9243C29.3972 29.071 29.4796 29.2701 29.4796 29.4777C29.4796 29.6852 29.3972 29.8843 29.2504 30.0311C29.1036 30.1778 28.9046 30.2603 28.697 30.2603Z"
          fill="#D4E3F3"
        />
        <path d="M42 17.7393H6V19.3045H42V17.7393Z" fill="#D4E3F3" />
      </svg>
    </IconContainer>
  )
}
